module.exports = __webpack_public_path__ + "img/1_2@2x.00a1e6d8.png";